
export class Colaborador {
    colaboradorid: number = 0;
    nombre: string = "";
    apellidopaterno: string = "";
    apellidomaterno: string = "";
    fechanacimiento: any = "";
    rfc: string = "";
    curp: string = "";
    nomina: string = "";
    genero: string = "";
    situacionconyugalid: number = 0;
    nacionalidadid: number = 0;
    nss: string = "";
    tiposanguineoid: number = 0;

    telefonofijo: string = "";
    telefonocelular: string = "";
    emailpersonal: string = "";
    emailinstitucional: string = "";
    cp: string = "";
    estadoid: number = 0;
    municipioid: number = 0;
    coloniaid: number = 0;
    otracolonia: string = "";
    calle: string = "";
    numero: string = "";
    numerointerior: string = "";
    nombrecontacto: string = "";
    telefonocontacto: string = "";
    parentescoid: number = 0;

    tipocolaboradorid: number = 0;
    estatuscolaboradorid: number = 1;
    usuario: string = "";

    experienciainstituto!: number;
    experienciasep: any = "";
    autorizaciondgb: string = "";
    autorizacionsep: string = "";

    foto: any = null;
    urlfotografia?: string;

    constructor(init?: Partial<Colaborador>) {
        Object.assign(this, init);
    }
}
